// ciclo-vida-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Arraste os pontos pra definir quando o cliente entra em risco e quando fica inativo.": "Arrastra los puntos para definir cuándo el cliente entra en riesgo y cuándo queda inactivo.",
    "Em risco a partir de": "En riesgo a partir de",
    "Inativo a partir de": "Inactivo a partir de",
};

export default catalogo;
